<template>
  <div class="page-container">
    <PageHeader title="试卷管理" show-breadcrumb />

    <!-- 搜索面板：名称/权限/类型/状态 -->
    <SearchPanel>
      <el-input v-model.trim="query.qpName" placeholder="试卷名称" clearable size="small" @keyup.enter.native="handleSearch" />
      <el-select v-model="query.qpAuth" placeholder="权限" clearable size="small">
        <el-option label="官方" :value="1" />
        <el-option label="个人" :value="2" />
      </el-select>
      <el-select v-model="query.qpTypeDo" placeholder="类型" clearable size="small">
        <el-option label="考试" :value="1" />
        <el-option label="练习" :value="2" />
      </el-select>
      <el-select v-model="query.qpStatus" placeholder="状态" clearable size="small">
        <el-option label="未发布" :value="1" />
        <el-option label="已发布" :value="2" />
        <el-option label="已暂停" :value="3" />
      </el-select>
      <template #actions>
        <el-button type="primary" icon="el-icon-search" size="small" @click="handleSearch">查询</el-button>
        <el-button icon="el-icon-refresh" size="small" @click="handleReset">重置</el-button>
        <el-button type="success" icon="el-icon-plus" size="small" @click="handleAdd">新增试卷</el-button>
      </template>
    </SearchPanel>

    <TablePanel title="试卷列表">
      <el-table :data="list" v-loading="loading" size="small" stripe :height="tableHeight">
        <el-table-column type="index" label="序号" width="70" align="center" />
        <el-table-column prop="qpName" label="试卷名称" min-width="200" align="center" show-overflow-tooltip />
        <el-table-column label="权限" min-width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" :type="row.qpAuth === 1 ? 'primary' : 'info'">{{ row.qpAuth === 1 ? '官方' : '个人' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="类型" min-width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" :type="row.qpTypeDo === 1 ? 'primary' : 'success'">{{ row.qpTypeDo === 1 ? '考试' : '练习' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" min-width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" :type="statusTagType(row.qpStatus)">{{ statusText(row.qpStatus) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="qpNums" label="题数" min-width="80" align="center" />
        <el-table-column prop="qpScorePass" label="及格分" min-width="90" align="center" />
        <el-table-column prop="qpAnswerTimes" label="答卷数" min-width="90" align="center" />
        <el-table-column label="操作" width="240" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button v-if="row.qpStatus !== 2" type="text" size="mini" style="color:#67c23a" @click="handleToggleStatus(row, 2)">发布</el-button>
            <el-button v-if="row.qpStatus === 2" type="text" size="mini" style="color:#e6a23c" @click="handleToggleStatus(row, 3)">暂停</el-button>
            <el-button type="text" size="mini" style="color:#409eff" @click="handleEdit(row)">编辑</el-button>
            <el-button type="text" size="mini" style="color:#f56c6c" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      />
    </TablePanel>

    <!-- 新增/编辑试卷弹框 -->
    <el-dialog :title="dialogType === 'add' ? '新增试卷' : '编辑试卷'" :visible.sync="dialogVisible" width="640px" v-dialog-drag-resize>
      <el-form ref="formRef" :model="form" :rules="rules" label-width="100px" size="small">
        <el-form-item label="试卷名称" prop="qpName">
          <el-input v-model.trim="form.qpName" placeholder="请输入试卷名称" />
        </el-form-item>
        <el-form-item label="试卷类型" prop="qpTypeDo">
          <el-radio-group v-model="form.qpTypeDo">
            <el-radio :label="1">考试</el-radio>
            <el-radio :label="2">练习</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="开始时间">
              <el-date-picker v-model="form.qpStartTime" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选填" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间">
              <el-date-picker v-model="form.qpEndTime" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选填" style="width:100%" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="题目数量">
              <el-input-number v-model="form.qpNums" :min="0" controls-position="right" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="及格分">
              <el-input-number v-model="form.qpScorePass" :min="0" :max="100" controls-position="right" style="width:100%" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="题目分组">
          <el-select v-model="form.qtcIds" multiple filterable placeholder="选择题目分类（可多选）" style="width:100%">
            <el-option v-for="item in classList" :key="item.qtcId" :label="item.qtcName" :value="item.qtcId" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="submitLoading" @click="submitDialog">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'
import SearchPanel from '@/components/SearchPanel.vue'
import TablePanel from '@/components/TablePanel.vue'
import { getZqpkQuestionPaperList, addZqpkQuestionPaper, updateZqpkQuestionPaper, deleteZqpkQuestionPaper, updateZqpkQuestionPaperStatus, getZqpkQuestionTopicClassList } from '@/api/api'

const STATUS_MAP = { 1: { label: '未发布', type: 'info' }, 2: { label: '已发布', type: 'success' }, 3: { label: '已暂停', type: 'warning' } }

export default {
  name: 'QuestionPaper',
  components: { PageHeader, SearchPanel, TablePanel },
  data () {
    return {
      loading: false,
      tableHeight: 400,
      list: [],
      query: { qpName: '', qpAuth: '', qpTypeDo: '', qpStatus: '' },
      page: { currentPage: 1, pageSize: 10, total: 0 },
      classList: [],
      dialogVisible: false,
      dialogType: 'add',
      submitLoading: false,
      form: { qpId: null, qpName: '', qpTypeDo: 1, qpStartTime: '', qpEndTime: '', qpNums: 0, qpScorePass: 0, qtcIds: [] },
      rules: {
        qpName: [{ required: true, message: '请输入试卷名称', trigger: 'blur' }],
        qpTypeDo: [{ required: true, message: '请选择试卷类型', trigger: 'change' }]
      }
    }
  },
  created () {
    this.fetchList()
    this.fetchClassList()
  },
  mounted () {
    this.$nextTick(this.calcTableHeight)
    window.addEventListener('resize', this.calcTableHeight)
  },
  beforeDestroy () { window.removeEventListener('resize', this.calcTableHeight) },
  methods: {
    statusText (s) { return (STATUS_MAP[s] && STATUS_MAP[s].label) || '-' },
    statusTagType (s) { return (STATUS_MAP[s] && STATUS_MAP[s].type) || 'info' },
    calcTableHeight () {
      const el = this.$el.querySelector('.el-table')
      if (!el) return
      this.tableHeight = window.innerHeight - el.getBoundingClientRect().top - 80
    },
    async fetchList () {
      this.loading = true
      try {
        const params = { ...this.query, currentPage: this.page.currentPage, pageSize: this.page.pageSize }
        const res = await getZqpkQuestionPaperList(params)
        this.list = res.data || []
        this.page.total = res.total || 0
      } catch (e) { this.list = []; this.page.total = 0 } finally { this.loading = false }
    },
    async fetchClassList () {
      try {
        const res = await getZqpkQuestionTopicClassList({ currentPage: 1, pageSize: 999 })
        this.classList = res.data || []
      } catch (e) { this.classList = [] }
    },
    handleSearch () { this.page.currentPage = 1; this.fetchList() },
    handleReset () { this.query = { qpName: '', qpAuth: '', qpTypeDo: '', qpStatus: '' }; this.handleSearch() },
    handleSizeChange (size) { this.page.pageSize = size; this.handleSearch() },
    handlePageChange (page) { this.page.currentPage = page; this.fetchList() },
    // qtcIds 归一化为数组（兼容后端返回字符串）
    normalizeQtcIds (val) {
      if (Array.isArray(val)) return val
      if (val == null || val === '') return []
      return String(val).split(',').filter(Boolean).map(Number)
    },
    handleAdd () {
      this.dialogType = 'add'
      this.form = { qpId: null, qpName: '', qpTypeDo: 1, qpStartTime: '', qpEndTime: '', qpNums: 0, qpScorePass: 0, qtcIds: [] }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    handleEdit (row) {
      this.dialogType = 'edit'
      this.form = {
        qpId: row.qpId,
        qpName: row.qpName || '',
        qpTypeDo: row.qpTypeDo || 1,
        qpStartTime: row.qpStartTime || '',
        qpEndTime: row.qpEndTime || '',
        qpNums: row.qpNums != null ? Number(row.qpNums) : 0,
        qpScorePass: row.qpScorePass != null ? Number(row.qpScorePass) : 0,
        qtcIds: this.normalizeQtcIds(row.qtcIds)
      }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    submitDialog () {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        // qtcIds 以逗号分隔字符串提交，qtcName 同步拼接分类名
        const qtcIdsArr = this.form.qtcIds || []
        const qtcName = qtcIdsArr.map(id => {
          const c = this.classList.find(it => it.qtcId === id)
          return c ? c.qtcName : ''
        }).filter(Boolean).join(',')
        const payload = {
          qpName: this.form.qpName,
          qpTypeDo: this.form.qpTypeDo,
          qpStartTime: this.form.qpStartTime || '',
          qpEndTime: this.form.qpEndTime || '',
          qpNums: this.form.qpNums,
          qpScorePass: this.form.qpScorePass,
          qtcIds: qtcIdsArr.join(','),
          qtcName
        }
        this.submitLoading = true
        try {
          if (this.dialogType === 'add') {
            await addZqpkQuestionPaper(payload)
            this.$message.success('新增成功')
          } else {
            payload.qpId = this.form.qpId
            await updateZqpkQuestionPaper(payload)
            this.$message.success('编辑成功')
          }
          this.dialogVisible = false
          this.fetchList()
        } catch (e) {} finally {
          this.submitLoading = false
        }
      })
    },
    // 发布 / 暂停切换
    async handleToggleStatus (row, target) {
      const tip = target === 2 ? '确定发布该试卷？发布后用户端可参与答题。' : '确定暂停该试卷？'
      try { await this.$confirm(tip, '提示', { type: 'warning' }) } catch { return }
      try {
        await updateZqpkQuestionPaperStatus({ qpId: row.qpId, qpStatus: target })
        this.$message.success('操作成功')
        this.fetchList()
      } catch (e) {}
    },
    async handleDelete (row) {
      try { await this.$confirm('确定删除该试卷？', '提示', { type: 'warning' }) } catch { return }
      try {
        await deleteZqpkQuestionPaper({ qpId: row.qpId })
        this.$message.success('删除成功')
        this.fetchList()
      } catch (e) {}
    }
  }
}
</script>
